import explorerModeSwitched, { ExplorerModeSwitchedEvent } from "../../events/selection/explorer_mode_switched";
import getFloorId from "../../services/getters/floor_getters/get_floor_id";
import inspectionModeSelected, { InspectionModeSelectedEvent } from "../../events/selection/inspection_mode_selected";
import getMostRecentPhotoScanDatasetForFloor from "../../services/getters/scan_dataset_getters/get_most_recent_photo_scan_dataset_for_floor";
import getMostRecentScanDatasetForFloor from "../../services/getters/scan_dataset_getters/get_most_recent_scan_dataset_for_floor";
import getProjectIdFromLocation from "../../services/getters/location_metadata/get_project_id_from_location";
import getScanDatasetId from "../../services/getters/scan_dataset_getters/get_scan_dataset_id";
import toViewerScanDataset, { ToViewerScanDatasetEvent } from "../../events/routing/to_viewer_scan_dataset";
import { AvvirThunk } from "../make_eventful_action";
import { InspectionMode } from "../../models/domain/enums/inspection_modes";

export type DispatchedEvents = InspectionModeSelectedEvent | ExplorerModeSwitchedEvent | ToViewerScanDatasetEvent;

// Deviation is computed from pointcloud data, so it opens on the floor's latest capture that has
// one; every other mode works from photos. A floor with no pointcloud falls back to the latest
// photo, and a floor with neither leaves the selection where it is.
const switchExplorerMode = (inspectionMode: InspectionMode): AvvirThunk<void, DispatchedEvents> => {
  return (dispatch, getState) => {
    // The mode change itself still goes out as inspectionModeSelected, which the filter reducer
    // and event tracking listen to; explorerModeSwitched only marks it as the user's own.
    dispatch(inspectionModeSelected(inspectionMode));
    dispatch(explorerModeSwitched());

    const state = getState();
    const scanned = inspectionMode === InspectionMode.inspect ? getMostRecentScanDatasetForFloor(state, {}) : null;
    const capture = scanned || getMostRecentPhotoScanDatasetForFloor(state, {});

    if (capture != null && capture.firebaseId !== getScanDatasetId(state, {})) {
      // The dropdown's own effect follows the scan dataset with the matching photo session.
      dispatch(toViewerScanDataset(getProjectIdFromLocation(state, {}), getFloorId(state, {}), capture.firebaseId));
    }
  };
};

/** NOT an eventful action! */
export default switchExplorerMode;
